import { useEffect } from 'react'
import '../../styles/Toast/ToastBase.css'
import successIcon from '../../media/toast/check-circle.svg'
import errorIcon from '../../media/toast/x-circle.svg'
import infoIcon from '../../media/toast/info-circle.svg'
import { AnimatePresence, motion } from 'framer-motion'
import { useGlobalContent } from '../../context/helpersProvider'

export const ToastBase = (props: any) => {
  const { showToast, setShowToast } = useGlobalContent()
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowToast({ open: 'false', type: '', message: '' })
    }, 5000)
    return () => clearTimeout(timer)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showToast])

  return (
    <>
      <AnimatePresence>
        {showToast.open === 'true' && (
          <motion.div key='toast' className={`toast-container`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
            <div className={`toast-header ${showToast.type === 'success' ? 'toast-success' : showToast.type === 'error' ? 'toast-error' : showToast.type === 'info' && 'toast-info'}`}>
              {showToast.type === 'success' && <img src={successIcon} className='toast-img' alt='' />}
              {showToast.type === 'error' && <img src={errorIcon} className='toast-img' alt='' />}
              {showToast.type === 'info' && <img src={infoIcon} className='toast-img' alt='' />}
              <div className='toast-title'>Message</div>
            </div>
            <div className='separador-t'> </div>
            <div className='toast-content'>
              <div className='toast-description'>{showToast.message}</div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
